export const AlertTrainingTours = {
    AlertTrainingAlertPage: 'alertTrainingAlertPage',
    AlertTrainingClaimAlert: 'alertTrainingClaimAlert',
    AlertTrainingAlertDetail: 'alertTrainingAlertDetail',
    AlertTrainingSelectMultiOutcome: 'alertTrainingSelectMultiOutcome',
    AlertTrainingObservations: 'alertTrainingObservations',
    AlertTrainingAddNote: 'alertTrainingAddNote',
    AlertTrainingCongrats: 'alertTrainingCongrats',
};

export const AlertTrainingElementIds = {
    AlertCard: 'alert-card',
    AlertFooterButtons: 'alert-footer-buttons',
    OtherActions: 'other-actions',
    SelectCareProvided: 'adl-help',
    AddNote: 'add-Note',
};

export const AlertTrainingElementSelectors = Object.entries(AlertTrainingElementIds).reduce(
    (selectors, [key, value]) => ({ ...selectors, [key]: `#${value}` }),
    {} as Record<keyof typeof AlertTrainingElementIds, string>
);

export const AlertTrainingViewportIds = {
    AlertsPage: 'alertsPageViewport',
    AlertFooterButtons: 'alertFooterButtons',
    CareProvided: 'careProvidedViewport',
    AddNote: 'addNoteViewport',
};
